module.exports = __webpack_public_path__ + "img/pig1.92c01d54.jpg";